module.exports = __webpack_public_path__ + "img/pyszne.3b71708c.png";